<button
  *ngIf="visible"
  type="button"
  class="app-nav-back btn btn-link border-0 p-0 d-inline-flex align-items-center text-decoration-none flex-shrink-0"
  [class.app-nav-back--compact]="!showLabel"
  (click)="onBackClick($event)"
  [attr.aria-label]="ariaLabel"
  [attr.title]="ariaLabel"
>
  <svg cIcon name="cilChevronLeft" size="lg" class="app-nav-back__icon flex-shrink-0"></svg>
  <span class="app-nav-back__label text-truncate" *ngIf="showLabel">{{ label }}</span>
</button>
